import React from 'react';
import { Brand } from '../types/BookingTypes';
import { useNavigate } from 'react-router-dom';

interface BrandSelectorProps {
  brands: Brand[];
  selectedBrand: Brand | null;
}

const BrandSelector: React.FC<BrandSelectorProps> = ({ brands, selectedBrand }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white rounded-xl shadow-sm">
      <div className="px-4 py-3 border-b border-gray-100">
        <h3 className="text-base font-medium text-gray-800">Select Brand</h3>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-3 gap-3">
          {brands.map((brand) => (
            <button
              key={brand.id}
              className={`relative flex flex-col items-center justify-center p-3 rounded-xl transition-all duration-200 ${
                selectedBrand?.id === brand.id 
                  ? 'bg-blue-50 border-2 border-blue-500' 
                  : 'bg-gray-50/50 border border-gray-100 hover:border-blue-200 hover:bg-blue-50/50 active:scale-95'
              }`}
              onClick={() => {
                navigate(`/brand/${brand.id}`);
              }}
            >
              <div className="w-12 h-12 mb-2 flex items-center justify-center">
                <img 
                  src={brand.logo} 
                  alt={brand.name} 
                  className="w-full h-full object-contain" 
                />
              </div>
              <span className="text-xs font-medium text-center text-gray-700">{brand.name}</span>
              {selectedBrand?.id === brand.id && (
                <div className="absolute top-2 right-2">
                  <i className="fas fa-check-circle text-blue-500 text-sm"></i>
                </div>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandSelector; 